<template>
  <transition name="fade" v-if="rendered">
    <router-view v-if="fullscreen" />

    <MainLayout id="app" v-else>
      <Header slot="header">
        <!-- <i-button @click="open(true)">打开提醒（仅标题）</i-button> -->
        <!--        {{selected}}-->
        <ul class="head-menu">
          <li class="left" v-for="(m, index) in carte" @click="showCurrentClickMenu(m)" :key="m.id + 1"
            :class="{ isSelected: m.id === isSelected }" v-if="index < 7">
            <Icon class="nav-icon head-nav-icon" :title="m.text" :type="m.icon" style="font-size: 16px;"></Icon>
            <span class="head-nav-title">{{ m.text }}</span>
          </li>
          <li v-if="carte.length >= 8">
            <Dropdown>
              <Icon class="nav-icon head-nav-icon" type="ios-more" />
              <span style="color:#ffffff">更多</span>
              <DropdownMenu slot="list" class="dropdownclass">
                <DropdownItem :selected="m.id === isSelected" v-for="(m, index) in carte" v-if="index >= 7" :key="m.id + 1"
                  @click.native="showCurrentClickMenu(m)">
                  <Icon class="nav-icon head-nav-icon" :title="m.text" :type="m.icon"></Icon>{{ m.text }}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </li>

        </ul>

        <!--        <div class="slideLeft" @click="slideActive('right')">-->
        <!--          <Icon type="ios-arrow-back" />-->
        <!--        </div>-->
        <!--        <div class="slideRight" @click="slideActive('left')">-->
        <!--          <Icon type="ios-arrow-forward" />-->
        <!--        </div>-->
        <bind-user style="margin-right: 10px;z-index: 99" v-show="isShow()" />
        <Button type="primary" @click="goToIndex" style="margin-right: 10px">首页</Button>
        <Dropdown style="margin-right: 20px" placement="top-end">
          <Button type="primary" style="color:#ffffff">
            <span class="current" v-if="currentUser">{{ currentUser.userName }}</span>
            <span class="old" v-if="!currentUser">{{ name }}</span>&nbsp;
            <!-- 当前岗位:<span class="userStation" v-if="currentUser">{{currentUser.userStationText}}</span><span class="userStation" v-if="!currentUser">{{userStationText}}</span>
            当前职务:<span class="userRank" v-if="currentUser">{{currentUser.userRankText}}</span><span class="userRank" v-if="!currentUser">{{userRankText}}</span>-->
            <!--当前机构:<span class="userRank" v-if="currentUser">{{currentUser.unitName}}</span><span class="userRank" v-if="!currentUser">{{unitName}}</span>
            -->
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem >
              <Quit></Quit>
            </DropdownItem>
            <DropdownItem divided>
              <ChangePwd></ChangePwd>
            </DropdownItem>
<!--            <DropdownItem divided>-->
<!--              <WxBind></WxBind>-->
<!--            </DropdownItem>-->
          </DropdownMenu>
        </Dropdown>
      </Header>

      <Menu ref="menu" slot="aside" />

      <router-view :key="$route.name" />

      <change-pwd-not-close ref="changePwdNotCloseRef" v-show="false"/>
      <change-pwd2 ref="changePwdNotCloseRef2" v-show="false"/>
    </MainLayout>
  </transition>
</template>

<script>
import _ from 'lodash';
import { mapState, mapMutations } from 'vuex';
import {checkLogin, getCurrposition, getInfo, checkpwd, justPasswordExpired} from '@/api/login';
import { queryMenus, querySubMenus } from '@/api/menus';

import MainLayout from './components/layout/MainLayout';
import Header from './components/commons/Header';
import Menu from './components/commons/Menu';
import ChangePwd from './components/commons/ChangePwd';
import Quit from './components/commons/Quit';
import UserRank from './components/commons/UserRank';
import WxBind from './components/commons/WxBind'
import BindUser from './components/commons/BindUser'
import ChangePwdNotClose from './components/commons/ChangePwdNotClose';
import ChangePwd2 from './components/commons/ChangePwd2.vue';

// import layui from '../layui/layui.js'

// layui.use('layim', function(im) {
//   console.log('im is', im)
// })
export default {
  name: 'App',

  components: {
    MainLayout,
    Header,
    Menu,
    ChangePwd,
    Quit,
    UserRank,
    WxBind,
    BindUser,
    ChangePwdNotClose,
    ChangePwd2
  },

  data() {
    return {
      name: '',
      unitName: '',
      userStationText: '',
      userRankText: '',
      messageParams: '带到Message组件的参数',
      changeMenu: 'PLATFORM',
      isActive: 'PLATFORM',
      isUnRead: '',
      isSelected: ''
    };
  },

  computed: {
    open(nodesc) {
      this.$Notice.open({
        title: '这是通知标题',
        desc: nodesc
          ? ''
          : '这里是通知描述这里,是通知描述这里是通知描述这里,是通知描述这里,是通知描述这里是通知描述这里是通知描述'
      });
    },
    ...mapState({
      rendered: 'rendered'
    }),

    isAdmin() {
      return (
        this.currentUser.userCode === '230' ||
        this.currentUser.unitCode === '93'
      );
    },

    fullscreen() {
      const route = this.$route;
      return route.meta && route.meta.fullscreen;
    },

    currentUser() {
      if (this.$store.state.currentUser) {
        this.showEditPassWord()
      }
      return this.$store.state.currentUser;
    },

    carte() {
      return this.$store.state.menuList;
    }

  },
  watch: {},
  methods: {
    showEditPassWord() {
      this.$nextTick(() => {
        checkpwd({password: 'chushimima'}).then(resp => {
          if (resp === true) {
            this.$refs.changePwdNotCloseRef.$children[0].open()
          }else {
            justPasswordExpired().then(resp => {
              if (resp === true) {
                this.$refs.changePwdNotCloseRef2.$children[0].open()
              }
            })
          }
        })
      })
    },
    ...mapMutations(['SET_AUTHORIZES']),
    slideActive(type) {
      let liElement = $('.head-menu').find('li');
      let allLiWidth = 0;
      for (let i = 0; i < liElement.length; i++) {
        allLiWidth +=
          $(liElement[i]).width() +
          parseFloat($(liElement[i]).css('marginRight'));
      }
      let headWidth = $('.head-menu').width();
      if (headWidth < allLiWidth) {
        let translateWidth = headWidth - allLiWidth;
        if (type === 'left') {
          $('.head-menu li').css(
            'transform',
            'translateX(' + translateWidth + 'px)'
          );
        } else if (type === 'right') {
          $('.head-menu li').css('transform', 'translateX(0px)');
        }
      }
    },
    ...mapMutations(['setScreenSize']),
    goToIndex() {
      location.href = '/';
    },
    change(val) {
      this.changeMenu = val;
      this.isActive = val;
      this.$refs['menu'].getMenus(val);
      this.$router.replace({
        name: 'dashboard'
      });
    },
    showCurrentClickMenu(m) {
      this.isSelected = m.id;
      $('.nav-item').hide();
      $('#' + m.id).show();
      this.toggle(m);
    },
    showCurrentClickMenu2(aa) {
      alert(111)
    },
    reload() {
      // 处理菜单
      let str = localStorage.getItem('breadcrumbList');
      if (str) {
        const arr = JSON.parse(str)
        setTimeout(() => {
          arr[0].state = true
          this.showCurrentClickMenu(arr[0])
        }, 1000)
      }
    },

    toggle(menu) {
      this.$store.state.menuList.forEach(m => {
        if (menu.id === m.id) {
          this.$set(m, 'state', true);
        } else {
          this.$set(m, 'state', false);
        }
      });
    },

    resize: _.throttle(function resize() {
      const width = document.body.clientWidth;
      let size;

      if (width > 1280) {
        size = 'large';
      } else if (width > 768) {
        size = 'small';
      } else {
        size = 'small';
      }

      this.setScreenSize(size);

      this.$root.$emit('resize');
    }, 36),

    full() {
      alert('fullScreen');
    },

    homePage() {
      this.$router.replace({
        name: 'dashboard'
      });
    },
    checkLogin,
    isShow() {
      return this.$store.state.authorizesInfo.jsczFlag
    }
  },

  async mounted() {
    const that = this;
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        that.checkLogin().then(res => {
          if (res) {
            console.log('已登录');
          } else {
            var name = that.$route.name;
            if (
              name == 'ssologin' ||
              name == 'register' ||
              name == 'forgetpassword' ||
              name == 'ZlxxDetailForWeb' ||
              name == 'sspy' ||
              name == 'resetpassword'
            ) {
            } else {
              that.$router.replace({
                name: 'login'
              });
            }
          }
        });
      }
    });
    window.addEventListener('resize', this.resize);
    this.resize();

    const user = await getCurrposition().then(res => {
      this.$store.state.currentUser = res;
      // this.$centitIM({
      //   userCode: res.userUnitId,
      //   userName: res.userName
      // })
    });

    if (user) {
      this.name = user.userName;
      this.userStationText = user.userStationText;
      this.unitName = user.unitName;
      this.userRankText = user.userRankText;
    }

    getInfo().then(re => {
      if (re) {
        this.$store.commit('SET_AUTHORIZES', { allAuthorizes: re.userInfo.allAuthorizes, authorizes: re.userInfo.authorizes, jsczFlag: re.jsczFlag })
        // this.jsczFlag = re.jsczFlag
        // alert(re.jsczFlag)
      } else {
        this.$store.commit('SET_AUTHORIZES', { allAuthorizes: {}, authorizes: {}, jsczFlag: false })
        // this.$store.state.authorizesInfo = {allAuthorizes: {}, authorizes: {}}
      }
    })
  },

  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  created() {
    this.reload();
  }
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    Arial, sans-serif;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

//html {
//  margin: 0;
//  padding: 0;
//  border: 0;
//  -webkit-text-size-adjust: 100%;
//  -ms-text-size-adjust: 100%;
//  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
//
//}

*::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}

*::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

*::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);

}

body {
  // overflow-y: hidden;
}

#app {
  width: 100vw;
  // min-width: 1280px;
  height: 100vh;
  overflow: hidden;
  font-size: 12px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ivu-table-row-highlight td,
.ivu-table-stripe .ivu-table-body tr.ivu-table-row-highlight:nth-child(2n) td,
.ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-highlight:nth-child(2n) td,
tr.ivu-table-row-highlight.ivu-table-row-hover td {
  background-color: #fff9d1 !important;
}

.ivu-loading-bar-inner-color-primary {
  background-color: #eff02d !important;
}

.ivu-modal-body {
  // 最外层定义最高级，对某些页面有影响
  // position: relative !important;
}

// 固定表格内容每一行的高度，内容超出显示滚动条（staticTable）
.staticTable {
  .ivu-table-row {
    height: 100px;

    .ivu-table-cell {
      overflow-y: auto;
      max-height: 100%;
    }
  }
}

.head-menu {
  position: absolute;
  left: 0px;
  list-style: none;
  width: calc(100% - 280px);
  height: 64px;
  white-space: nowrap;
  line-height: 38px;
  padding-top: 14px;
  li {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    font-size: 14px !important;
    font-weight: 500 !important;
    //margin-right: 1%;
  }
  li.left {
    margin-left: 15px;
    margin-right: 20px;
  }

  li:hover {
    color: rgba(255, 255, 255, 0.996);
  }

  li.isSelected {
    color: rgba(255, 255, 255, 1);
    border-bottom: 3px solid #ffffff;
  }

  .slideLeft,
  .slideRight {
    display: none;
  }
}

.dropdownclass {
  white-space: normal;
  line-height: 40px;

  li {
    cursor: pointer;
    display: block;
    text-align: left;
    color: #999999;
    font-size: 14px !important;
    font-weight: 400 !important;
    //margin-right: 1%;
    padding-left: 15px;
    padding-right: 20px;
    transition: 0.3s all;
  }

  li:hover {
    color: #cda337;
  }

  li.ivu-dropdown-item-selected {
    color: #cda337;
  }

}

@media screen and (max-width: 1600px) {
  .head-nav-icon {
    display: none;
  }

  .slideLeft,
  .slideRight {
    display: none;
  }

  .head-nav-title {
    font-size: 15px;
    font-weight: 500;
  }
}

@media screen and (max-width: 1280px) {
  .head-menu {
    overflow: hidden;
    width: calc(100% - 316px);
    left: 18px;
    margin-top: -7px\9;
  }

  .slideLeft,
  .slideRight {
    cursor: pointer;
  }

  .slideLeft {
    position: absolute;
    left: 0;
    display: inline-block;
    top: 50%;
    margin-top: -10px;
    color: #fff;
    font-size: 18px;
  }

  .slideRight {
    display: inline-block;
    position: absolute;
    right: 280px;
    top: 50%;
    margin-top: -10px;
    color: #fff;
    font-size: 18px;
  }

  .slideLeft:hover {
    color: red;
  }

  .slideRight:hover {
    color: red;
  }
}

.centit-form-view {
  height: auto !important;
}

</style>
 <!--[if IE]>
  <style>
    @media screen and (max-width: 1280px) {
      .head-menu {
      margin-top: -7px;
      }
    }
  </style>
<![endif]-->
